<template>
  <v-card class="mb-3" color="grey lighten-4">
    <v-card-title>Day {{ day }}</v-card-title>
    <v-card-text>
      <v-list>
        <draggable :list="services" group="services" @change="onDragChange"
          ><v-list-item v-for="service in services" :key="service.uid">
            <v-list-item-icon>
              <v-icon>{{ supplierTypeIcon(service.serviceType) }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <v-container fluid py-0>
                  <v-row>
                    {{ service.supplierName }} - {{ service.serviceName }} -
                    Duration:&nbsp;
                    <v-edit-dialog>
                      <strong>{{ service.duration }}</strong>
                      <template v-slot:input>
                        <v-text-field
                          v-model="service.duration"
                          type="number"
                          label="Edit"
                          single-line
                          min="1"
                          :max="itemMaxDuration(service.serviceType)"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </v-row>
                  <v-row v-if="isExpanded(service)">
                    <v-col cols="12" class="py-0">
                      <div
                        v-for="extra in service.extras"
                        :key="extra.title"
                        class="d-flex align-center pl-4 py-1"
                      >
                        <v-icon small class="mr-2"
                          >mdi-subdirectory-arrow-right</v-icon
                        >
                        <span class="mr-2">{{ extra.name }}</span>
                        <confirmation-dialog
                          :item="service"
                          @onConfirm="onExtraRemove(extra, service)"
                        >
                          <v-btn small icon class="mx-0">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon small color="pink" v-on="on"
                                  >mdi-delete</v-icon
                                >
                              </template>
                              <span>Remove Extra</span>
                            </v-tooltip>
                          </v-btn>
                          <p slot="message">This will remove service.</p>
                        </confirmation-dialog>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-row align="center">
                <v-btn
                  text
                  small
                  icon
                  v-if="service.extras && service.extras.length > 0"
                  @click="toggleExtras(service)"
                >
                  <v-icon color="yellow darken-2">mdi-star</v-icon>
                </v-btn>
                <v-btn icon small @click="onEditItemPrices(service)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        v-on="on"
                        :color="customPricingFlagColor(service)"
                        >mdi-currency-usd</v-icon
                      >
                    </template>
                    <span>Pricing</span>
                  </v-tooltip>
                </v-btn>
                <v-btn
                  icon
                  small
                  class="mx-0"
                  @click="onServiceDelete(service)"
                >
                  <v-icon small color="pink">mdi-delete</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-drag</v-icon>
                </v-btn>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </draggable>
      </v-list>
      <div v-if="debug">
        <code>{{ services.map((item) => item.supplierName) }}</code>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import ConfirmationDialog from "../../shared/ConfirmationDialog";

export default {
  name: "template-builder-day-by-day-item",

  props: {
    day: {
      type: Number,
      default: () => 1,
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: Number,
      default: () => 1,
    },
  },

  mixins: [SupplierTypeIconMixin],

  components: { draggable, ConfirmationDialog },

  data() {
    return {
      debug: false,
      services: [...this.templateItems.filter((item) => item.day == this.day)],
      expanded: [],
    };
  },

  computed: {},

  methods: {
    onEditItemPrices(payload) {
      this.$emit("custom-price", { ...payload });
    },
    onDragChange(payload) {
      this.$emit("change", {
        day: this.day,
        order: this.services.map((item) => item.uid),
        ...payload,
      });
    },
    onServiceDelete(service) {
      this.$emit("delete", { ...service });
    },
    itemMaxDuration(type) {
      let maxDuration = this.duration - this.day;
      if (type != "ACCOMMODATION") {
        maxDuration++;
      }
      if (maxDuration == 0) {
        maxDuration = 1;
      }
      return maxDuration;
    },
    customPricingFlagColor(item) {
      return item.customPricing ? "green darken-2" : "blue lighten-1";
    },
    toggleExtras(item) {
      const index = this.expanded.indexOf(item.uid);
      if (index === -1) {
        this.expanded.push(item.uid);
      } else {
        this.expanded.splice(index, 1);
      }
    },
    isExpanded(item) {
      return this.expanded.includes(item.uid);
    },
    extraTemplateDays(item) {
      const days = [];
      for (
        let i = parseInt(item.day);
        i <= Number(item.day) + Number(item.duration) - 1;
        i++
      ) {
        days.push(i);
      }
      return days;
    },
    extraAvailableDurations(item, extra) {
      let maxDur = Number(item.day) + Number(item.duration) - Number(extra.day);
      if (maxDur <= 0) {
        maxDur = 1;
      }
      return [...Array(maxDur).keys()].map((i) => ++i);
    },
    onSaveExtraDay(item, extra) {
      this.$emit("onSaveExtraDay", { item, extra });
    },
    onExtraRemove(extra, item) {
      this.$emit("onExtraRemove", { extra, item });
    },
  },

  watch: {
    templateItems(newItems) {
      this.services = [...newItems.filter((item) => item.day == this.day)];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateBuilderDayByDayItem.vue